export default "__VITE_ASSET__GZfKwr2D__"